import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuItem } from 'react-pro-sidebar';
import { Popover, Button, Divider } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const NEW_UI_BASE_URL = process.env.REACT_APP_NEW_UI_URL || 'https://njs.sendelemental.com';

export default function NewUINavItem ({ label, path, oldPath, style }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (e) => {
        e.preventDefault();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const newUrl = `${NEW_UI_BASE_URL}${path}`;

    return (
        <>
            <MenuItem
                onClick={handleClick}
                style={{
                    ...style,
                    opacity: 0.45,
                    cursor: 'pointer',
                }}
            >
                {label}
            </MenuItem>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                transformOrigin={{ vertical: 'center', horizontal: 'left' }}
            >
                <Button
                    href={newUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<OpenInNewIcon />}
                    sx={{ m: 1, textTransform: 'none' }}
                >
                    Use new UI
                </Button>
                {oldPath && (
                    <>
                        <Divider />
                        <Button
                            component={Link}
                            to={oldPath}
                            onClick={handleClose}
                            sx={{ m: 1, textTransform: 'none' }}
                        >
                            Stay on old UI
                        </Button>
                    </>
                )}
            </Popover>
        </>
    );
}
